import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import CustomThemeProvider from './components/theme/ThemeProvider';
import { Amplify } from 'aws-amplify';
import App from './App';
import { store } from './services/store';
import awsExports from './aws-exports';

// Configure Amplify
try {
  Amplify.configure(awsExports);
} catch (error) {
  console.warn('Error configuring Amplify:', error);
}

// Theme wrapper component
const ThemedApp = () => {
  return (
    <CustomThemeProvider>
      <App />
    </CustomThemeProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemedApp />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
